import store from 'store';
import actions from 'store/actions/global';

export const setCollapsed = async (collapsed) => {
  return store().dispatch(actions.setCollapsed(collapsed));
};
